(function () {
  'use strict';

  window.BM = window.BM || {};
  if (window.BM.__customMountainMediaLightboxLoaded) return;
  window.BM.__customMountainMediaLightboxLoaded = true;

  // BM-LIGHTBOX: Standard-Produktsection und individuelles Bergtemplate.
  const ROOT_SELECTOR = '[data-bm-media-lightbox-root], .bm_customMountain_root[data-bm-section-id]';
  // Deutliche Wischbewegungen von normalem Tippen und kleinen Bewegungen trennen.
  const SWIPE_DISTANCE_PX = 70;
  const SWIPE_DIRECTION_RATIO = 1.5;

  function init(root) {
    if (root.bmMediaLightboxDestroy) return;
    const dialog = root.querySelector('[data-bm-media-lightbox]');
    const gallery = root.querySelector('.product__media-wrapper');
    if (!dialog || !gallery || typeof dialog.showModal !== 'function') return;

    const image = dialog.querySelector('[data-bm-media-image]');
    const caption = dialog.querySelector('[data-bm-media-caption]');
    const position = dialog.querySelector('[data-bm-media-position]');
    const closeButton = dialog.querySelector('[data-bm-media-close]');
    const previousButton = dialog.querySelector('[data-bm-media-prev]');
    const nextButton = dialog.querySelector('[data-bm-media-next]');
    const entries = Array.from(dialog.querySelectorAll('[data-bm-media-id]'));
    if (!image || !caption || !position || !closeButton || !entries.length) return;

    let activeIndex = 0;
    let openedBy = null;
    let touchStart = null;

    function showImage(index) {
      activeIndex = (index + entries.length) % entries.length;
      const entry = entries[activeIndex];
      image.src = entry.dataset.src;
      image.alt = entry.dataset.alt;
      image.width = Number(entry.dataset.width);
      image.height = Number(entry.dataset.height);
      caption.textContent = entry.dataset.alt;
      position.textContent = `${activeIndex + 1} / ${entries.length}`;
    }

    function open(event) {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('modal-opener button[data-media-id]');
      if (!button || !gallery.contains(button)) return;
      const index = entries.findIndex(entry => entry.dataset.bmMediaId === button.dataset.mediaId);
      if (index < 0) return;

      // Vor dem nativen modal-opener reagieren, damit nur ein Dialog geöffnet wird.
      event.preventDefault();
      event.stopImmediatePropagation();
      openedBy = button;
      showImage(index);
      if (!dialog.open) dialog.showModal();
      closeButton.focus({ preventScroll: true });
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    function previous() { showImage(activeIndex - 1); }
    function next() { showImage(activeIndex + 1); }

    function onClose() {
      touchStart = null;
      if (openedBy?.isConnected) openedBy.focus({ preventScroll: true });
      openedBy = null;
    }

    function backdrop(event) {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    }

    function keydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      if (event.key === 'ArrowLeft') previous();
      else next();
    }

    function startTouch(event) {
      touchStart = event.touches.length === 1
        ? { x: event.touches[0].clientX, y: event.touches[0].clientY, atTop: dialog.scrollTop === 0 }
        : null;
    }

    function endTouch(event) {
      const start = touchStart;
      touchStart = null;
      if (!start || event.touches.length || event.changedTouches.length !== 1) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;
      if (Math.abs(dx) >= SWIPE_DISTANCE_PX && Math.abs(dx) > Math.abs(dy) * SWIPE_DIRECTION_RATIO) {
        if (dx < 0) next();
        else previous();
      } else if (dy >= SWIPE_DISTANCE_PX && dy > Math.abs(dx) * SWIPE_DIRECTION_RATIO &&
                 start.atTop && dialog.scrollTop === 0) close();
    }

    function cancelTouch() { touchStart = null; }

    gallery.addEventListener('click', open, true);
    closeButton.addEventListener('click', close);
    previousButton?.addEventListener('click', previous);
    nextButton?.addEventListener('click', next);
    dialog.addEventListener('close', onClose);
    dialog.addEventListener('click', backdrop);
    dialog.addEventListener('keydown', keydown);
    dialog.addEventListener('touchstart', startTouch, { passive: true });
    dialog.addEventListener('touchend', endTouch, { passive: true });
    dialog.addEventListener('touchcancel', cancelTouch, { passive: true });

    root.bmMediaLightboxDestroy = () => {
      close();
      gallery.removeEventListener('click', open, true);
      closeButton.removeEventListener('click', close);
      previousButton?.removeEventListener('click', previous);
      nextButton?.removeEventListener('click', next);
      dialog.removeEventListener('close', onClose);
      dialog.removeEventListener('click', backdrop);
      dialog.removeEventListener('keydown', keydown);
      dialog.removeEventListener('touchstart', startTouch);
      dialog.removeEventListener('touchend', endTouch);
      dialog.removeEventListener('touchcancel', cancelTouch);
      delete root.bmMediaLightboxDestroy;
    };
  }

  function initAll() { document.querySelectorAll(ROOT_SELECTOR).forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(root => root.bmMediaLightboxDestroy?.());
  });
})();
